// File: frontend/src/config/fitenkoRailIcons.js
// Version: 1.0 (quick-260909-qa3)
// Date: 2026-09-09
// Назначение: линейные значки левой колонки арендатора fitenko.
//
// 🔴 КАРТА ОТДЕЛЬНАЯ, а не поле в ICONS. `ICONS` из fitenkoNav.js — ЭМОДЗИ, и их
//    рендерит MLG: двадцать значков в пяти выпадающих (Navbar.js NavDropdown).
//    Подмена там стёрла бы у MLG весь набор.
//
// 🔴 Ключ — id РАЗДЕЛА (FITENKO_SECTIONS), а не ключ назначения: колонка рисует
//    разделы. Раздел без записи в карте рисуется БЕЗ значка и не роняет колонку.
//
// Все девять имён проверены в установленном lucide-react@0.263.1.

import {
    Home,
    Calendar,
    Inbox,
    Users,
    Briefcase,
    History,
    Cpu,
    TrendingUp,
    Newspaper,
    Settings,
} from 'lucide-react';

export const RAIL_ICONS = {
    today: Home,
    calendar: Calendar,
    inbox: Inbox,
    clients: Users,
    cases: Briefcase,
    history: History,      // раздел объявлен и не рендерится — значок ждёт экрана
    ai_ops: Cpu,
    growth: TrendingUp,
    blog: Newspaper,
    settings: Settings,
};

export default RAIL_ICONS;
